import useSWR from 'swr';

import fetcher from 'lib/fetcher';
import useBoundStore from 'store';

export type APIApartmentComplexBuildingsRes = {
  buildings: { id: number; title: string; commissioningQuarter: string | null }[];
};

const useApartmentComplexBuildings = () => {
  const selectedSellComplexId = useBoundStore((s) => s.selectedSellComplex.id);

  const { data, error, isLoading } = useSWR(
    selectedSellComplexId !== -1 && `/apartment-complexes/${selectedSellComplexId}/buildings`,
    (url) =>
      fetcher.swr<APIApartmentComplexBuildingsRes>(url).then((res) => {
        res.buildings.forEach((b, i) => (b.title ||= `Дом №${i + 1}`));
        return res;
      }),
  );

  return { buildings: data?.buildings ?? [], error, isLoading };
};

export default useApartmentComplexBuildings;
